module.exports = __webpack_public_path__ + "img/chevron-bar-up.77c613bc.svg";